function capitalizeFirstLetter(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

function getRandomString(length) {
  var text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxy';

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

// Receipt/invoice downloads are white-labeled: the file name has to carry the
// master account's brand (MissionPrint, etc.), not ours.
function receiptFileName(masterAccountName, id) {
  const brand = String(masterAccountName || '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .trim();

  return `${brand || 'MyCreativeShop'}_#${id}.pdf`;
}

export { capitalizeFirstLetter, getRandomString, receiptFileName };
